export default "__VITE_ASSET__B$b7OPlp__"